import { render, staticRenderFns } from "./LevelUpComponent.vue?vue&type=template&id=35bd182d&scoped=true"
import script from "./LevelUpComponent.vue?vue&type=script&lang=js"
export * from "./LevelUpComponent.vue?vue&type=script&lang=js"
import style0 from "./LevelUpComponent.vue?vue&type=style&index=0&id=35bd182d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd182d",
  null
  
)

export default component.exports